import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "import-id-container" }
const _hoisted_2 = { class: "import-id-wrapper" }
const _hoisted_3 = { class: "page-header" }
const _hoisted_4 = { class: "step-dots" }
const _hoisted_5 = { class: "main-content" }
const _hoisted_6 = {
  key: 0,
  class: "upload-zone"
}
const _hoisted_7 = { class: "upload-inner" }
const _hoisted_8 = {
  key: 0,
  class: "upload-actions"
}
const _hoisted_9 = {
  key: 0,
  class: "result-zone"
}
const _hoisted_10 = {
  key: 0,
  class: "alert-container"
}
const _hoisted_11 = {
  key: 1,
  class: "stats-container"
}
const _hoisted_12 = { class: "stat-box" }
const _hoisted_13 = { class: "stat-number" }
const _hoisted_14 = { class: "stat-box" }
const _hoisted_15 = { class: "stat-number" }
const _hoisted_16 = { class: "footer" }

import { ref } from "vue";
import { InboxOutlined, QuestionCircleOutlined, Statistic } from "@ant-design/icons-vue";
import type { UploadChangeParam } from "ant-design-vue";
import { TelegramClient } from "@/websocket/Client";

// 定义事件

export default /*@__PURE__*/_defineComponent({
  __name: 'ImportXlsxID',
  emits: ["import-id-success", "import-id-error"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const fileList = ref<any[]>([]);
const loading = ref(false);
const importStatus = ref<{
  message: string;
  type: "success" | "error" | "info";
} | null>(null);

// 添加解析结果的响应式引用
const parseResults = ref<{
  totalRows: number;
  columnCount: number;
  columns: string[];
  previewColumns: any[];
  previewData: any[];
} | null>(null);

// 添加删除加载状态
const deleteLoading = ref(false);

// 添加步骤控制
const currentStep = ref(0);

// 添加重置方法
const resetImport = () => {
  currentStep.value = 0;
  clearFile();
  parseResults.value = null;
  importStatus.value = null;
};

// 上传前校验
const beforeUpload = (file: File) => {
  const isTxt = file.type === "text/plain";
  if (!isTxt) {
    importStatus.value = {
      message: "只能上传 TXT 文件！",
      type: "error",
    };
    return false;
  }
  return true;
};

// 文件变化处理
const handleChange = (info: UploadChangeParam) => {
  fileList.value = info.fileList.slice(-1); // 只保留最后上传的文件
};

// 清除文件
const clearFile = () => {
  fileList.value = [];
  importStatus.value = null;
  console.log("clearFileID");
};


const isInteger = (str) => {
  if (typeof str !== 'string') {
    return false; // 确保输入是字符串
  }
  const num = parseInt(str, 10); // 使用 parseInt 并指定进制
  return !isNaN(num) && num.toString() === str && Number.isInteger(num);
};

 
// 处理导入
const handleImport = async () => {
  console.log("handleImportID");
  if (fileList.value.length === 0) {
    importStatus.value = {
      message: "请先选择要导入的文件",
      type: "error",
    };
    return;
  }

  loading.value = true;
  importStatus.value = {
    message: "正在解析文件...",
    type: "info",
  };

  try {
    const file = fileList.value[0].originFileObj;
    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const content = e.target?.result as string;
        // 按行分割文本内容并过滤空行
        const lines = content.split('\n').filter(line => line.trim());
        
        // 将每行数据转换为所需格式，只有 strAccount
        const listTmp = lines.map(line => {
          const strTelegramNo = line.trim();
          const isNum = isInteger(strTelegramNo);
          if(isNum)
          {
              return {
              strTelegramNo,
              strAccount:"",
              strNickName: "",
              strPhone: "",
              strManage: ""
            };
          }
          else
          {
              return {
                strTelegramNo:"",
                strAccount:"",
                strNickName: "",
                strPhone: "",
                strManage: ""
              };
          }

        });
        let list = listTmp.filter((value) => value.strTelegramNo != "");
        console.log("解析后的数据:", list);
        console.log("数据条数:", list.length);

        const client = TelegramClient.getInstance();
        const result = await client.loadPrivateChatList(list);

        if (result && result.code === 1) {
          currentStep.value = 2;
          importStatus.value = {
            message: result.msg,
            type: "success",
          };
          emit("import-id-success", list);
        } else {
          importStatus.value = {
            message: `导入失败: ${result?.msg || "未知错误"}`,
            type: "error",
          };
          emit("import-id-error", result?.msg || "导入失败");
        }
      } catch (error) {
        const errorMessage = (error as Error).message;
        importStatus.value = {
          message: "文件解析失败：" + errorMessage,
          type: "error",
        };
        emit("import-id-error", errorMessage);
      }
    };

    reader.onerror = () => {
      const errorMessage = "文件读取失败";
      importStatus.value = {
        message: errorMessage,
        type: "error",
      };
      emit("import-id-error", errorMessage);
    };

    reader.readAsText(file); // 修改为文本方式读取
  } catch (error) {
    const errorMessage = "导入过程出错：" + (error as Error).message;
    importStatus.value = {
      message: errorMessage,
      type: "error",
    };
    emit("import-id-error", errorMessage);
  } finally {
    loading.value = false;
  }
};

// 添加删除所有私聊的处理函数
const handleDeleteAll = async () => {
  try {
    deleteLoading.value = true;
    const client = TelegramClient.getInstance();
    const account = localStorage.getItem("username") || "";
    const token = "1234567890";
    const result = await client.deleteAllPrivateChat(account, token);
    
    // 确保在删除操作后显示提示
    currentStep.value = 1; // 切换到结果显示状态
    
    if (result && result.code === 1) {
      importStatus.value = {
        message: result.msg,
        type: "success",
      };
    } else {
      importStatus.value = {
        message: `删除失败: ${result?.msg || "未知错误"}`,
        type: "error",
      };
    }
  } catch (error) {
    currentStep.value = 1; // 错误时也切换状态
    const errorMessage = "删除过程出错：" + (error as Error).message;
    importStatus.value = {
      message: errorMessage,
      type: "error",
    };
  } finally {
    deleteLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", null, "导入私聊数字ID", -1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (step) => {
            return _createElementVNode("span", {
              key: step,
              class: _normalizeClass(['dot', { active: currentStep.value >= step - 1 }])
            }, null, 2)
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (currentStep.value === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_a_upload_dragger, {
                    fileList: fileList.value,
                    "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
                    name: "file",
                    multiple: false,
                    "before-upload": beforeUpload,
                    onChange: handleChange,
                    accept: ".txt",
                    class: "uploader"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_unref(InboxOutlined), { class: "icon" }),
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-group" }, [
                          _createElementVNode("p", { class: "main-text" }, "点击或拖拽文件上传"),
                          _createElementVNode("p", { class: "sub-text" }, "支持 .txt 格式")
                        ], -1))
                      ])
                    ]),
                    _: 1
                  }, 8, ["fileList"]),
                  (fileList.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          loading: loading.value,
                          onClick: handleImport
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("导入")
                          ])),
                          _: 1
                        }, 8, ["loading"]),
                        _createVNode(_component_a_button, { onClick: clearFile }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode("取消")
                          ])),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (currentStep.value > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (importStatus.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_a_alert, {
                          message: importStatus.value.message,
                          type: importStatus.value.type,
                          "show-icon": "",
                          class: _normalizeClass(["custom-alert", importStatus.value.type]),
                          banner: ""
                        }, null, 8, ["message", "type", "class"])
                      ]))
                    : _createCommentVNode("", true),
                  (parseResults.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(parseResults.value.totalRows), 1),
                          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "stat-label" }, "总行数", -1))
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(parseResults.value.columnCount), 1),
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "stat-label" }, "字段数", -1))
                        ]),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "stat-box" }, [
                          _createElementVNode("span", { class: "stat-number success" }, "成功"),
                          _createElementVNode("span", { class: "stat-label" }, "状态")
                        ], -1))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_16, [
        (currentStep.value > 0)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              onClick: resetImport
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("重新导入")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_popconfirm, {
          title: "确定要删除所有私聊数据吗?",
          onConfirm: handleDeleteAll,
          okText: "确定",
          cancelText: "取消"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              danger: "",
              loading: deleteLoading.value
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("删除全部")
              ])),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})